<template>
  <div>
    <div class="card card-20 payment-summary">
      <div class="payment-details">
        <div class="pb-0">
          <div>{{$t('sendmoney-transaction-no')}}</div>
          <div>{{transactionId}}</div>
        </div>
        <div class="pb-0">
          <div class="pb-0">{{dateCreated}}</div>
          <div class="col-status badge pb-0" :class="deliveryStatusClass">{{deliveryStatusName}}</div>
        </div>
      </div>
      <div class="payment-details payment-details-10 pt-md">
        <div class="pb-0">
          <div>{{$t('sendmoney-text-recipient')}}</div>
          <div class="fw-bold">{{(this.beneficiaryAlias == '' || this.beneficiaryAlias == null) ? this.beneficiaryFirstName : this.beneficiaryAlias}}</div>
        </div>
        <div class="pb-0">
          <div>{{$t('sendmoney-label-payment-method')}}</div>
          <div>{{paymentMethod}}</div>
        </div>
        <div>
          <div class="pb-0">{{$t('sendmoney-settlement-no')}}</div>
          <div class="pb-0">S{{settlementId}}</div>
        </div>
      </div>
      <div class="payment-details payment-details-4 pt-md">
        <div>
          <div class="wandr-level-3">{{$t('sendmoney-label-recipient-receives')}}</div>
          <div class="wandr-level-3">{{this.formatCurrency(transaction.homeAmount, 2) || 0}} {{transaction.homeCurrency}}</div>
        </div>
        <div class="text-color-gray">
          <div>{{$t('general-text-exchange-rate')}}</div>
          <div>{{ (rateBaseCurrencyId == 189) ? transaction.hostCurrency + " / " + transaction.homeCurrency : transaction.homeCurrency + " / " + transaction.hostCurrency }} {{activeDisplayRate}}</div>
        </div>
      </div>
      <div class="payment-details2 pt-20 pb-md">
        <div>
          <div class="wandr-level-3">{{$t(labelYouPay)}}</div>
          <div class="wandr-level-3"> {{this.formatCurrency(totalPayable, 2) || 0}} {{transaction.hostCurrency}}</div>
        </div>
      </div>
    </div>

    <div class="card card-20">
      <div class="beneficiary-card display-flex align-items-center justify-content-space-between">
        <div class="col-bank mr-media">
          <img :src="getBankImg(this.bankId)"/>
        </div>
        <div class="col-details">
          <div class="wandr-level-3">{{(this.beneficiaryAlias == '' || this.beneficiaryAlias == null) ? this.beneficiaryFirstName : this.beneficiaryAlias}}</div>
          <div class="wandr-caption-2" v-if="this.deliveryMethodId == 1 || this.deliveryMethodId == 6 || this.deliveryMethodId == 9">{{this.bankName}}({{this.bankAccountNo}})</div>
          <div class="wandr-caption-2" v-if="this.deliveryMethodId == 3">{{this.collectionAgent}}</div>
          <div class="wandr-caption-2" v-if="this.deliveryMethodId == 4">{{this.province}}&nbsp;&bull;&nbsp;{{this.city}}</div>
          <div class="wandr-caption-2" v-if="this.deliveryMethodId == 0">{{this.billingOrg}}&nbsp;&bull;&nbsp;{{this.bankAccountNo}}</div>
        </div>
        <div class="col-country">
          <img :src="getCircleSmallFlagImg(this.homeCountryId)"/>
        </div>
      </div>

      <!-- TRX PROGRESS STATUS -->
      <ul class="StepProgress">
        <li v-for="(progress, index) in stepProgress" :key="index"   :class="progress.class">
          <div :class="( (index == 'transit' || index == 'complete' || index == 'pay' ) && !isSettled ) ? 'tx-progress-title text-color-gray' : 'tx-progress-title' ">{{$t(progress.title)}}</div>
          <div v-if=" index == 'create' && transactionId > 0" class="tx-progress-note fs-12">{{$t('sendmoney-transaction-no')}} {{transactionId}} </div>
          <div v-if=" index == 'pay' && isSettled" class="tx-progress-note"><b>{{paymentMethod}}</b></div>
          <div v-if=" index == 'pay' && isSettled" class="tx-progress-note"><b>{{$t('sendmoney-settlement-no')}} S{{settlementId}}</b></div>
          <div class="tx-progress-date">{{progress.date}}</div>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
  import { fxRateHelper as FX } from '@/plugins/helper'

  export default {

    props: { },
    data: function () {
      return {
        activeDisplayRate   : "",
        bankAccountNo       : "",
        bankId              : 0,
        bankName            : "",
        beneficiaryAlias    : "",
        beneficiaryFirstName: "",
        billingOrg          : "",
        city                : "",
        collectionAgent     : "",
        dateCreated         : "",
        deliveryMethodId    : 0,
        deliveryStatusId    : 0,
        deliveryStatusClass : "",
        deliveryStatusName  : "",
        hostCurrency        : "",
        homeCurrency        : "",
        homeCountryId       : 0,
        isMakePayment       : false,
        isSettled           : false,
        labelYouPay         : 'sendmoney-text-you-pay',
        paymentMethod       : "",
        paymentMethodId     : 0,
        province            : "",
        pageTitle           : "",
        rateBaseCurrencyId  : 0,
        settlementId        : 0,
        stepProgress        : {
          "create"          : { title:"sendmoney-step-transfer-created",   class: "StepProgress-item is-done", date: ""},
          "pay"             : { title:"sendmoney-step-payment-received",   class: "StepProgress-item",         date: ""},
          "transit"         : { title:"sendmoney-step-transfer-transit",   class: "StepProgress-item",         date: ""},
          "complete"        : { title:"sendmoney-step-transfer-completed", class: "StepProgress-item",         date: ""}
        },
        totalPayable        : 0,
        transactionId       : 0,
        transaction         : []
      }
    },

    mounted() {
      this.settlementId  = this.$store.state.transaction.settlementId
      this.isMakePayment = this.$store.state.transaction.isMakePayment

      if(this.settlementId > 0){
        this.getSettlementDetail()
      }else{
        this.$emit('errorTransactionJourney', "error-sendmoney-transaction-journey")
      }
    },

    methods: {
      getSettlementDetail(){
        const self = this
        const settlementDetails = this.$api.settlement.getSettlement(self.settlementId)
        self.showPreloader()
        settlementDetails.then(function(result) {
          self.$store.state.transaction.settlementDetail = result
          const trxDetail = result.transactionList[0]

          console.log("getSettlement", result)

          self.transaction          = trxDetail
          self.transactionId        = trxDetail.transactionId
          self.homeCountryId        = trxDetail.homeCountryId
          self.hostCurrency         = trxDetail.hostCurrency
          self.homeCurrency         = trxDetail.homeCurrency
          self.deliveryMethodId     = trxDetail.deliveryMethodId
          self.bankAccountNo        = trxDetail.beneficiaryBankAccountNo
          self.bankId               = trxDetail.beneficiaryBankId
          self.bankName             = trxDetail.beneficiaryBank
          self.beneficiaryAlias     = trxDetail.beneficiaryBankAccountName
          self.beneficiaryFirstName = trxDetail.beneficiaryName
          self.billingOrg           = trxDetail.beneficiaryName
          self.collectionAgent      = trxDetail.beneficiaryBank
          self.rateBaseCurrencyId   = trxDetail.exchangeRateBaseCurrencyId
          self.totalPayable         = result.totalAmountPayable

          self.deliveryStatusName   = self.getDeliveryStatusName(trxDetail.deliveryStatusId, trxDetail.deliveryStatus, trxDetail.agentPaymentStatusId);

          if(self.deliveryMethodId == 4){
            self.province           = trxDetail.province
            self.city               = trxDetail.city
          }

          self.activeDisplayRate    = FX.formatDisplayRate(trxDetail.exchangeRate, {countryId: self.homeCountryId, isDisplay: true})
          self.stepProgress['create'].date = self.getDateFormat(result.dateCreated, true)
          self.dateCreated                 = self.getDateFormat(result.dateCreated, false)

          if(result.paymentList.length > 0){
            const paymentList     = result.paymentList[0]
            self.paymentMethodId  = paymentList.paymentMethodId
            self.paymentMethod    = paymentList.paymentMethod
            self.isSettled        = paymentList.settled
            self.totalPayable     = parseFloat(self.totalPayable) + parseFloat(paymentList.fee)

            if(paymentList.settled){
              self.stepProgress['pay'].date = self.getDateFormat(paymentList.dateUpdated, true)
              self.dateCreated              = self.getDateFormat(paymentList.dateUpdated, false)
            }

            self.$store.state.transaction.isSettled       = paymentList.settled
            self.$store.state.transaction.paymentMethodId = paymentList.paymentMethodId
          }

          var classDone   = " StepProgress-item is-done"
          var classCancel = " StepProgress-item is-cancel"
          var classHide   = " d-none"
          var isShowCancel= false;

          const statusId        = trxDetail.deliveryStatusId
          const paymentStatusId = trxDetail.agentPaymentStatusId
          const daStatusId      = trxDetail.distributionPaymentStatusId

          self.labelYouPay = ( statusId >= 10 && paymentStatusId == 5) ? 'sendmoney-text-you-pay' : 'sendmoney-text-you-paid'

          self.deliveryStatusClass                   = "badge-" + statusId
          switch(statusId){
            case 80:
              //suspended
              self.stepProgress['pay'].class       = classHide
              self.stepProgress['transit'].class   = classHide
              self.stepProgress['complete'].class  = classCancel
              self.stepProgress['complete'].isShow = true
              self.stepProgress['complete'].title  = "sendmoney-step-transfer-suspended"

              self.pageTitle                         = 'sendmoney-page-title-transfer-suspended'

              
              break;
            case 10:
              console.log("Case 10")
              isShowCancel                           = true
              if(paymentStatusId == 5 ){ //upaid
                self.pageTitle                       = 'sendmoney-page-title-transfer-created'
                self.stepProgress['pay'].class       = "StepProgress-item"
              }else{
                self.pageTitle                       = 'sendmoney-page-title-in-transit'
                self.stepProgress['create'].class    = classDone
                self.stepProgress['pay'].class       = classDone
              }
            break
            case 35:
              console.log("Case 35")
              self.pageTitle                         = 'sendmoney-page-title-in-transit'
              self.stepProgress['create'].class      = classDone
              self.stepProgress['pay'].class         = classDone
              self.stepProgress['transit'].class     = classDone
              break
            case 60:
              console.log("Case 60 : cancelled")
              self.pageTitle                         = 'sendmoney-page-title-transfer-cancelled'
              self.stepProgress['create'].class      = classDone

              if(paymentStatusId == 5){ //Cancellation before pay
                self.stepProgress['pay'].class       = classHide
                self.stepProgress['transit'].class   = classHide
                self.stepProgress['complete'].class  = classCancel
                self.stepProgress['complete'].isShow = true
                self.stepProgress['complete'].title  = "sendmoney-step-transfer-cancelled"

              } else if (daStatusId == 90) { //Cancellation after transaction failed
                self.stepProgress['pay'].class       = classDone
                self.stepProgress['transit'].class   = classCancel
                self.stepProgress['complete'].class  = classCancel
                self.stepProgress['transit'].title   = "sendmoney-step-transfer-unsuccessful"
                self.stepProgress['complete'].title  = "sendmoney-step-transfer-cancelled"

              } else { //Cancellation after pay
                self.stepProgress['pay'].class       = classDone
                self.stepProgress['transit'].class   = classHide
                self.stepProgress['complete'].class  = classCancel
                self.stepProgress['complete'].title  = "sendmoney-step-transfer-cancelled"
              }
            break
            case 70:
              console.log("Case 70")
              self.pageTitle                       = 'sendmoney-page-title-transfer-refunded'
              self.stepProgress['create'].class    = classDone
              self.stepProgress['pay'].class       = classDone
              self.stepProgress['transit'].class   = classDone
              self.stepProgress['complete'].class  = classCancel
              self.stepProgress['complete'].title  = "sendmoney-step-transfer-refunded"
              break
            case 50:
              console.log("Case 50")
              self.pageTitle                       = 'sendmoney-page-title-transfer-unsuccessful'
              isShowCancel                         = true
              self.stepProgress['create'].class    = classDone
              self.stepProgress['pay'].class       = classDone
              self.stepProgress['transit'].class   = classDone
              self.stepProgress['complete'].class  = classCancel
              self.stepProgress['complete'].title  = "sendmoney-step-transfer-unsuccessful"
              break
            case 40:
              console.log("Case 40")
              self.pageTitle = 'sendmoney-page-title-transfer-completed'
              self.stepProgress['create'].class   = classDone
              self.stepProgress['pay'].class      = classDone
              self.stepProgress['transit'].class  = classDone
              self.stepProgress['complete'].class = classDone
              break
            default:
          }

          if(self.isMakePayment){
            self.pageTitle = "my-transaction-details-page-title"
          }

          self.$store.state.transaction.isShowCancel  = isShowCancel
          self.hidePreloader()
          self.$emit('completeLoadTransactionJourney', self.pageTitle)
        })
      },

      formatCurrency(num, dec) {
        let val = (Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100).toFixed(dec)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
    }
  }
</script>